import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { clearStorageKeepTheme } from '../components/Shared/ThemeContext';

const ControlBase = () => {

    const navigate = useNavigate();
    useEffect(()=>{
        clearStorageKeepTheme();
        navigate("/controlbase/login")

    },[])
  return (
    <div>ControlBase</div>
  )
}

export default ControlBase